module.exports = "/_next/static/images/carlos-4dd68cc1f68bdf83185c8b15fb4467a1.png";